import asyncComponentLoader from '@/utils/react/loader';

const LazyBillBar = asyncComponentLoader(() => import('./BillBar'));

export default LazyBillBar;
